import TraineeList from "./TraineeList";

export default TraineeList;
